import React, { useState } from 'react';
import { FaArrowLeft, FaBriefcase, FaGraduationCap } from 'react-icons/fa';
import MarketingJobForm from './MarketingJobForm';

interface CareersSectionProps {
  onTrackSubmit?: () => void;
}

const CareersSection: React.FC<CareersSectionProps> = ({ onTrackSubmit }) => {
  const [activeForm, setActiveForm] = useState<'careers' | 'collegeBrandAmbassador'>('careers');

  return (
    <div className="z-20 flex-shrink-0 py-8">
      <div className="relative min-h-[350px] lg:h-[calc(100vh-8rem)]">
        {/* Background Giant C */}
        <div
          className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-[30rem] opacity-25 pointer-events-none"
          style={{
            fontFamily: '"Anton", sans-serif',
            background: 'linear-gradient(135deg, #fbbf24 0%, #3b82f6 45%, #14b8a6 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            filter: 'drop-shadow(0 20px 60px rgba(0,0,0,0.35))',
          }}
        >
          C
        </div>

        <div className="relative h-full flex items-center justify-center">
          <div className="colorful-ring bg-BLACK/96 backdrop-blur-2xl rounded-3xl p-6 lg:p-10 w-full h-auto lg:h-full transition-colors shadow-2xl flex flex-col overflow-hidden">

            {/* Header */}
            <div className="text-center mb-6">
              <h2 className="text-3xl lg:text-4xl font-bold text-WHITE mb-2">Join Our Team</h2>
              <div className="bg-WHITE/10 backdrop-blur-xl rounded-2xl px-6 py-3 mx-auto w-fit border border-WHITE/15 shadow-lg">
                <p
                  className="text-base lg:text-lg font-bold text-center leading-relaxed"
                  style={{
                    background: 'linear-gradient(90deg, #000000 0%, #0066cc 50%, #000000 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text',
                  }}
                >
                  {activeForm === 'careers'
                    ? "We're looking for talented people to help grow CollectedAF."
                    : "Apply to become a College Brand Ambassador and help grow CollectedAF on campus."}
                </p>
              </div>
            </div>

            {/* Tab Switcher */}
            <div className="flex gap-2 mb-6 mx-auto">
              <button
                type="button"
                onClick={() => setActiveForm('careers')}
                className={`flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-semibold transition-all duration-300 border ${
                  activeForm === 'careers'
                    ? 'bg-WHITE/[0.12] border-WHITE/25 text-WHITE shadow-[0_0_16px_rgba(255,255,255,0.06)]'
                    : 'bg-WHITE/[0.04] border-transparent text-WHITE/60 hover:bg-WHITE/[0.08] hover:border-WHITE/10'
                }`}
              >
                <div
                  className="w-7 h-7 rounded-full flex items-center justify-center border"
                  style={{
                    background: activeForm === 'careers' ? 'rgba(59,130,246,0.25)' : 'rgba(59,130,246,0.15)',
                    borderColor: activeForm === 'careers' ? 'rgba(59,130,246,0.3)' : 'transparent',
                  }}
                >
                  <FaBriefcase size={11} style={{ color: '#60a5fa' }} />
                </div>
                Careers
              </button>
              <button
                type="button"
                onClick={() => setActiveForm('collegeBrandAmbassador')}
                className={`flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-semibold transition-all duration-300 border ${
                  activeForm === 'collegeBrandAmbassador'
                    ? 'bg-WHITE/[0.12] border-WHITE/25 text-WHITE shadow-[0_0_16px_rgba(255,255,255,0.06)]'
                    : 'bg-WHITE/[0.04] border-transparent text-WHITE/60 hover:bg-WHITE/[0.08] hover:border-WHITE/10'
                }`}
              >
                <div
                  className="w-7 h-7 rounded-full flex items-center justify-center border"
                  style={{
                    background: activeForm === 'collegeBrandAmbassador' ? 'rgba(16,185,129,0.25)' : 'rgba(16,185,129,0.15)',
                    borderColor: activeForm === 'collegeBrandAmbassador' ? 'rgba(16,185,129,0.3)' : 'transparent',
                  }}
                >
                  <FaGraduationCap size={12} style={{ color: '#34d399' }} />
                </div>
                College Ambassador
              </button>
            </div>

            {/* Scrollable form area */}
            <div className="flex-1 overflow-y-auto pr-1">
              <MarketingJobForm
                variant={activeForm}
                onTrackSubmit={onTrackSubmit}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CareersSection;
